export { default as jeevikaLogo } from './jeevikalogo.gif';
export { default as ashokStambh } from './ashokStambhlogo.png';
export { default as biharSarkarlogo } from './biharsarkarlogo.png';
export { default as askDidiLogo } from './askDidiLogo.jpeg';
export { default as botLogo } from './bot-logo.png';
export { default as logoSmart } from './logoSmart.png';
export { default as namLogo } from './nam.png';
export { default as namasteGirl } from './namasteGirl.jpg';